@let isContractReadOnly = !!(isContractReadOnly$ | async);
<div
  class="tab-pane fade flex-even active show"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
>
  <!--  *ngIf="contractDetail$ | async as contractDetail"-->
  <div class="d-flex flex-column h-100">
    <div class="row mt-2">
      <div class="col-12 col-md">
        <div class="form-group-title my-1" translate>
          CONTRACT_FIELDSET_DOCUMENTS
        </div>
        <div class="row mt-2">
          <div class="col-12">
            @if (sortedDocuments$ | async; as sortedDocuments) {
              @for (document of sortedDocuments; track document.id) {
                <app-tab-document-request-card
                  [documentModel]="document"
                  (onNewDocumentRefresh)="onNewDocument($event)"
                  (onDocumentDownload)="onDocumentDownload($event)"
                  (onDocumentEdit)="onDocumentEdit($event)"
                  (onDocumentDelete)="onDocumentDelete($event)"
                  [isEditMode]="!isContractReadOnly"
                />
              }
            }
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 col-md">
        <div class="form-group-title my-1" translate>
          CONTRACT_FIELDSET_DOCUMENTS_AVAILABLE
        </div>
        @if (this.allDocuments$ | async; as availableDocuments) {
          <app-generic-grid
            [data]="availableDocuments"
            [tabViewName]="'allDocuments'"
            [dragAndDrop]="!isContractReadOnly"
            [rowHeight]="25"
            [pageSize]="10"
            (onActionClickedSetRowData)="onSetRowData($event)"
          />
          <!--              dragAndDrop ou ajouter input -->
        }

        <div class="row mt-2">
          <div class="col-6">
            <app-document-upload-drag-and-drop
              [entityId]="this.contactId.toString()"
              [entityType]="'Contact'"
              [multiple]="true"
              [button_label]="'CONTACT_LBL_DOCUMENTS_ADD'"
              [isDefaultUse]="false"
              [showDescription]="false"
              (onAddedDocumentRefresh)="onRefreshContactDocument($event)"
              [isEditMode]="true"
            />
          </div>
          <div class="col-6">
            <app-document-upload-drag-and-drop
              [entityId]="this.contractId.toString()"
              [entityType]="'Contract'"
              [multiple]="true"
              [button_label]="'CONTRACT_LBL_DOCUMENTS_ADD'"
              [isDefaultUse]="false"
              [showDescription]="false"
              (onAddedDocumentRefresh)="onRefreshContractDocument($event)"
              [isEditMode]="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
